import { PERMISSIONS } from '../../constants'
import list from './FillinContractPriceAlertList'

export default {
  list,
  name: 'fillin-contract-price-diff-alerts',
  permissions: [PERMISSIONS.ADMIN],
  options: { label: 'Alerta de preço nos abastecimento com contrato' }
}
